export default function (Component) {
  Component.__i18n = Component.__i18n || []
  Component.__i18n.push({
    "locale": "",
    "resource": {
      "fr": {
        "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Répartition des magasins"])},
        "subtitle": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Par segment de volume (ventes/mois)."])},
        "inactive": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Inactifs (0 vente)"])},
        "below_5": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Moins de 5 ventes/mois"])},
        "five_to_ten": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["5 à 10 ventes/mois"])},
        "ten_to_thirty": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["10 à 30 ventes/mois"])},
        "above_thirty": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Plus de 30 ventes/mois"])}
      },
      "en": {
        "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Store distribution"])},
        "subtitle": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["By volume segment (sales/month)."])},
        "inactive": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Inactive (0 sales)"])},
        "below_5": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Less than 5 sales/month"])},
        "five_to_ten": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["5 to 10 sales/month"])},
        "ten_to_thirty": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["10 to 30 sales/month"])},
        "above_thirty": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["More than 30 sales/month"])}
      }
    }
  })
}
